import useGlobalState from '@components/Hooks/useGlobalState';
import Error from '@Shared/Error';
import React from 'react';

const ContactAdminError: React.FC = () => {

  const [store,] = useGlobalState();

  return store.requested?.message ? (
    <Error>
      <h2>Error</h2>
      <p>{store.requested?.message}</p>
    </Error>
  ) : null;
}

export default ContactAdminError;